// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .deal-options--2Uk4n{--button-link-padding:0;--button-link-font-color:var(--primary-color);margin-bottom:20px}.precise-price-app .deal-options__title--37uMg{color:#333;font-size:18px;font-weight:700;line-height:30px;text-align:center;margin-bottom:10px}.precise-price-app .deal-options__description--3n54F{color:#333;font-size:16px;text-align:center}", ""]);
// Exports
exports.locals = {
	"dealOptions": "deal-options--2Uk4n",
	"dealOptionsTitle": "deal-options__title--37uMg",
	"dealOptionsDescription": "deal-options__description--3n54F"
};
module.exports = exports;
